import styled from 'styled-components'

import { Marker } from '../../../components/maps/ListingMap/markers'

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 32px;
  margin-right: 32px;

  &:last-child {
    margin-right: 0;
  }

  ${Marker} {
    width: 60px;
    height: 60px;
    margin-right: 8px;

    .icon,
    svg {
      display: inline-block;
      vertical-align: middle;
      width: 28px;
      font-size: 28px;
    }
  }
`
